__turbopack_context__.v({
  "blogContainer": "gDoxeq_blogContainer",
  "blogElement": "gDoxeq_blogElement",
  "root": "gDoxeq_root",
  "subtitle": "gDoxeq_subtitle",
  "textContent": "gDoxeq_textContent",
});
